import { useSelector } from "react-redux";

import { TalkState } from "../ducks";

export type UseTalk = () => TalkState;

export const useTalk: UseTalk = () => useSelector<{ talk: TalkState }, TalkState>(({ talk }) => talk);
